import { createSvgIcon } from "@mui/material";

export const LogoIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
        <path d="M8.75 5C5.30053 5 2.5 7.80053 2.5 11.25C2.5 14.6995 5.30053 17.5 8.75 17.5C12.1995 17.5 15 14.6995 15 11.25H8.75V5V5" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.25 8.75H17.5C17.5 5.29822 14.7018 2.5 11.25 2.5V8.75V8.75" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    'LogoIcon'
)
